// @flow

class YoutubeEmbed {
    el: HTMLElement;
    player: window.YT.Player;
    videoId: string;
    parent: ?Element;

    constructor(el: HTMLElement) {
        this.el = el;
        this.parent = this.el.parentElement;
        this.videoId = el.getAttribute("data-youtube-video-id") || "";
        if (!this.videoId) return;
        this.initialisePlayer();
    }

    initialisePlayer = () => {
        if (this.parent) {
            this.parent.classList.add("initialised");
        }
        this.player = new window.YT.Player(this.el, {
            videoId: this.videoId,
            playerVars: {
                autoplay: true,
            },
        });
    };

    play = () => {
        if (this.player && this.player.playVideo) {
            this.player.playVideo();
        }
    };

    pause = () => {
        if (this.player && this.player.pauseVideo) {
            this.player.pauseVideo();
        }
    };

    stop = () => {
        if (this.player && this.player.stopVideo) {
            this.player.stopVideo();
        }
    };

    destroy = () => {
        if (this.player && this.player.destroy) {
            this.player.destroy();
        }
        if (this.parent) {
            this.parent.classList.remove("initialised");
        }
    };
}

export default YoutubeEmbed;

// The following code initialised a player based on an element being clicked with data-youtube-embed attr
// This is used inside media galleries inside lightbox to initialise a player inline rather than opening
// another lightbox
window.addEventListener("click", (event: MouseEvent) => {
    if (event.target instanceof HTMLElement) {
        const clickedEl = event.target;
        const parentSelector = `[data-youtube-embed]`;
        const selector = `${parentSelector}, ${parentSelector} *`;
        if (event.target.matches(selector)) {
            const button = clickedEl.closest(parentSelector);
            if (button && button instanceof HTMLElement) {
                const el = document.getElementById(button.dataset.youtubeEmbed);
                if (el) {
                    new YoutubeEmbed(el);
                    button.remove();
                }
            }
        }
    }
});
